// 滚动到底部
export function scrollToBottom (element) {
  let scroll = true
  let height = 0
  function scrollDomToBottom () {
    if (element && height !== element.scrollHeight) {
      height = element.scrollHeight
      element.scrollTo(0, height)
    }
    if (scroll) {
      requestAnimationFrame(scrollDomToBottom)
    }
  }
  scrollDomToBottom()
  return () => { scroll = false }
}
//
// export const systemHelpMessage = `AI小助手是一款基于 Gemini Pro 大语言模型的对话式助手程序，旨在帮助EBS用户提高工作效率。
// 目前它可以提供以下功能：
// - 查询物料型号信息
// - 查询品牌信息
// - 查询外部公司信息
// - 智能对话
//
// ### 帮助手册
// 详细的使用方法和实现逻辑请查阅[《AI小助手》帮助手册](https://shimo.im/docs/913JMyemVWiw5mAE)
//
// ### 特别注意
// AI小助手生成的内容不一定准确，请注意核查！
//
// ### 反馈和建议
// 如果您对AI小助手有任何疑问和建议，请在下方对话框中输入并发送，即可与开发人员进行联系。开发人员会针对您的疑问进行解答，针对建议进行收集整理并排期加入到AI小助手中。`


export function getCurrentModelValue (models, cache) {
  if (cache && tools.findOption(models, cache)) {
    return cache
  }
  if (models.some(option => option.default)) {
    return models.find(option => option.default).value
  }
  return models[0]?.value
}

export function getModelsOptions (models) {
  return [
    {
      label: '字节DeepSeek',
      value: 'ark_deepseek'
    },
    {
      label: '字节豆包',
      value: 'ark_doubao'
    },
    {
      label: '阿里千问Plus',
      value: 'dashscope_qwen_plus'
    },
    {
      label: '官方DeepSeek',
      value: 'deepseek'
    },
    {
      label: '阿里DeepSeek',
      value: 'dashscope_deepseek'
    },
    {
      label: '阿里千问Turbo',
      value: 'dashscope_qwen_turbo'
    },
    {
      label: 'Kimi',
      value: 'kimi'
    },
    {
      label: '智谱清言Air',
      value: 'glm_4_air'
    },
    {
      label: '智谱清言Flash',
      value: 'glm_4_flash'
    },
    {
      label: '百度DeepSeek',
      value: 'qianfan_deepseek'
    }
  ].map(({label, value}) => {
    const option = tools.findOption(models, value)
    return {
      label: (option?.label ? `【${option.label}】` : '*') + label,
      value,
      default: option?.default
    }
  })
}
